import { CdkPortalOutletAttachedRef, ComponentPortal } from '@angular/cdk/portal';
import { Component, ComponentRef, EventEmitter, Inject, InjectionToken, Injector, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseView } from '../base-view';

export const OVERLAY_DATA = new InjectionToken<any>("OVERLAY_DATA");

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent extends BaseView {

  showActions: boolean;
  showCancel: boolean;
  title: string;

  componentPortal: ComponentPortal<any>;

  @Output() output = new EventEmitter<any>();
  @Output() exit = new EventEmitter<any>(); 

  constructor(
    protected _injector: Injector,
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      super(_injector)
  }

  ngOnInit() {
    this.title = this.data.title;
    this.showActions = this.data.showActions;
    this.showCancel = this.data.showCancel;
    this.componentPortal = new ComponentPortal(this.data.component);
  }

  setInput(ref: CdkPortalOutletAttachedRef) {
    ref = ref as ComponentRef<any>;
    ref.instance.input = this.data.componentInput;

    if(ref.instance.output) 
      this._subscription.add(ref.instance.output.subscribe(result => {this.output.emit(result); this.dialogRef.close()})); 
    if(ref.instance.exit) 
      this._subscription.add(ref.instance.exit.subscribe(result => {this.exit.emit(result); this.dialogRef.close()}));
  }

  closeAfterCancel(event){
    this.exit.emit();
    this.dialogRef.close()
  }
}
